import { EMPTY_OBJECT } from '../constants/common'
import { postApi } from '../utils/api'

export function logout({ options } = EMPTY_OBJECT) {
  return postApi({ endpoint: 'rest-auth/logout/', options })
}
